import React from 'react';
import CalendarDropdownMultiSelect from '@/components/Focus/common/CalendarDropdownMultiSelect';
import { Box, Typography } from '@mui/material';
import PlatformIcon from '@/components/_common/Table/Calendar/CalendarSharedComponents/PlatformIcon';
import { useAppSelector } from '@/redux/hooks';
import { selectAvailPlatform } from '@/redux/selectors/constantsSelectors';
import { StatusFilter as StatusFilterEnum } from '@/components/_common/Table/Calendar/SidePanel/components/ElementReadiness.constants';

interface Props {
  values: string[];
  options: { value: string; label: string }[];
  onChange: (platforms: string[]) => void;
  fullWidth?: boolean;
}

const PlatformFilter: React.FC<Props> = ({ values, options, onChange, fullWidth }) => {
  const allPlatforms = useAppSelector(selectAvailPlatform);

  const handleChange = (status: StatusFilterEnum, newValue: boolean) => {
    onChange(newValue ? [...values, status] : values.filter((value) => value !== status));
  };

  const handleToggleAll = () => {
    onChange(values.length > 0 ? [] : options.map((o) => o.value));
  };

  return (
    <CalendarDropdownMultiSelect
      label="Platform"
      options={options}
      selectedItems={values}
      buttonSx={{ width: fullWidth ? '100%' : undefined, textAlign: 'left' }}
      onChange={handleChange}
      onToggleAll={handleToggleAll}
      minWidth={450}
      renderLabel={(_, value) => (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <PlatformIcon name={value} size="small" disableTooltip />
          <Typography sx={{ whiteSpace: 'nowrap' }}>{allPlatforms[value]}</Typography>
        </Box>
      )}
    />
  );
};

export default PlatformFilter;
